export const comments = {
  "1": [
    {
      id: "c1-1",
      author: "扫街的老陈",
      createdAt: "2026-09-08 07:02",
      content: "我就是那个点去吃饭的。三块钱一碗阳春面，汤是热的，老板从来不催人，坐多久都行。",
      likes: 342,
      replies: [
        {
          id: "c1-1-1",
          author: "夜行的猫",
          createdAt: "2026-09-08 07:20",
          content: "没想到被本人回复了，这条我置顶一下，让更多人看到。",
          likes: 88,
        },
      ],
    },
    {
      id: "c1-2",
      author: "隔壁楼住户",
      createdAt: "2026-09-08 08:41",
      content: "这家我常去，中午的菜也不贵。老板人闷不爱说话，但做事很实在，碗筷都是自己一个个烫过的。",
      likes: 156,
    },
    {
      id: "c1-3",
      author: "路过的司机",
      createdAt: "2026-09-08 10:15",
      content: "我们跑夜班的都知道这个点。建议老板在门框上装个小灯，天冷了从街对面也能看见。",
      likes: 97,
    },
    {
      id: "c1-4",
      author: "小城故事多",
      createdAt: "2026-09-08 12:30",
      content: "看完有点想哭。城市里还是有很多人在默默做小事，只是平时不容易被看见。",
      likes: 210,
    },
  ],
  "3": [
    {
      id: "c3-1",
      author: "18楼设计",
      createdAt: "2026-09-08 00:12",
      content: "被点名了。吴师傅真的会记得谁没上车，有次我加班到十一点二十，他愣是在楼下等了我十分钟。",
      likes: 288,
      replies: [
        {
          id: "c3-1-1",
          author: "同层同事",
          createdAt: "2026-09-08 00:30",
          content: "同组的人路过。那晚我们一起下来的，他确实等了。",
          likes: 64,
        },
      ],
    },
    {
      id: "c3-2",
      author: "云谷物业",
      createdAt: "2026-09-08 09:05",
      content: "我们也在跟进，准备给末班车加一个实时到站提醒，方便大家掌握时间。谢谢分享。",
      likes: 173,
    },
    {
      id: "c3-3",
      author: "打工人日常",
      createdAt: "2026-09-08 11:48",
      content: "看到那句深夜里还亮着的楼层，突然就破防了。希望每个加班的人都能遇上这样的司机。",
      likes: 401,
    },
  ],
  "6": [
    {
      id: "c6-1",
      author: "公园常客",
      createdAt: "2026-09-05 22:30",
      content: "上周我也去了，放的是老片子。老人自己扛着音箱，散场还一个个捡垃圾，真的不容易。",
      likes: 219,
    },
    {
      id: "c6-2",
      author: "两个孩子的妈",
      createdAt: "2026-09-06 08:12",
      content: "我们家孩子每周都盼着周五。比在家看平板强多了，还能认识邻居家的小朋友。",
      likes: 145,
      replies: [
        {
          id: "c6-2-1",
          author: "带娃的爸爸",
          createdAt: "2026-09-06 09:00",
          content: "对对，我家也是。天气转凉了记得给孩子带件外套，晚上风大。",
          likes: 38,
        },
      ],
    },
    {
      id: "c6-3",
      author: "退休的王老师",
      createdAt: "2026-09-06 15:40",
      content: "谢谢大家的支持，片单还是会投票决定。如果有愿意帮忙搬设备的，欢迎周五提前来。",
      likes: 366,
    },
  ],
  "11": [
    {
      id: "c11-1",
      author: "住五楼的姑娘",
      createdAt: "2026-09-01 20:10",
      content: "我们群里现在买水果都先看公告再下单，价格清楚，省得互相猜。团长的字还挺好看。",
      likes: 176,
    },
    {
      id: "c11-2",
      author: "老杨的邻居",
      createdAt: "2026-09-01 21:35",
      content: "补充一句，她家团购的蔬菜确实比楼下超市新鲜，而且坏果会统一退款，不多问。",
      likes: 132,
    },
    {
      id: "c11-3",
      author: "做小生意的",
      createdAt: "2026-09-02 09:20",
      content: "透明这件事说起来简单，做起来难。尤其是把一个月挣多少钱都贴出来，需要的勇气不小。",
      likes: 254,
    },
  ],
  "12": [
    {
      id: "c12-1",
      author: "六楼阿姨",
      createdAt: "2026-08-31 08:40",
      content: "没想到被写出来了。今年番茄确实结得好，主要是楼上那几个年轻人浇得勤快。",
      likes: 298,
      replies: [
        {
          id: "c12-1-1",
          author: "顶楼的邻居",
          createdAt: "2026-08-31 09:05",
          content: "阿姨挑种子是一绝，明年多留点辣椒苗，我带同事来一起种。",
          likes: 57,
        },
      ],
    },
    {
      id: "c12-2",
      author: "刚搬来的租户",
      createdAt: "2026-08-31 12:15",
      content: "住进来第一周门口就多了袋小番茄，当时还以为是送错了。现在我开始轮到值日浇水了。",
      likes: 187,
    },
    {
      id: "c12-3",
      author: "别的小区居民",
      createdAt: "2026-09-01 10:05",
      content: "看得羡慕。请问花箱是在哪买的？物业那边需要提前报备吗，想在我们楼也试试。",
      likes: 96,
    },
  ],
};